/**
 * Capitalizes the first letter in a word or phrase.
 *
 * @param {string} value
 * @returns {string}
 * @example 'hello world' becomes 'Hello world'
 */
export const capitalize = (value) => {
  if (typeof value !== "string") {
    return value;
  }
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
};
